import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../theme/Component/BasicPage";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { OfficeEditor } from "../../Office/OfficeEditor";
import { CompanyEditor } from "../../Company/CompanyEditor";
import { _CashDeskAccountByofficecompany, _CreateMoneyBase } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { ThirdBankingAccountEditor } from "../../../../Talentohumano/ParametrosTalentoHumano/ThirdBankingAccount/ThirdBanking.editor";
import { InputDate } from "../../../../theme/Input/InputDate";
import { _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { BankAccountSelect } from "../../BankAccount/BankAccountSelect";
import { DocumentViewer } from "../../../../theme/Component/DocumentViewer";



export const CashDeskAccountByofficecompany = () => {

    const desk = useDataBean(_CashDeskAccountByofficecompany);
    const deskcreate = useDataBean(_CreateMoneyBase);
    const single = Singleton.getInstance();
    const [docs, setDocs] = useState<any>([]);
    const [conpany, setCompany] = useState<number>(null);
    const [office, setOffice] = useState<number>(null);
    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modalverdoc, setModalverdoc] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {

        desk.instance.getCashDeskAccountCatalog(office, null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    const create = () => {
        desk.setBean({
            AccountantDate: _single.getCurrenDate(),
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        desk.deleteItemVoid(desk.bean.IDCashDeskAccount).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        desk.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDCashDeskAccount', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Cuenta Débito', property: 'AccountantIDName', visible: true },
        { title: 'Responsable de la Caja', property: 'AccountName', visible: true },
        { title: 'Valor de la Base', property: 'BaseValue', visible: true },
        { title: 'Caja Destino', property: 'DestinityCash', visible: true },
        { title: 'Utiliza Presupuesto', property: 'UseBudget', visible: true },
        { title: 'Creado por', property: 'EmployeeName', visible: true },
        { title: 'Oficina a la que pertenece', property: 'OfficeName', visible: true },
        { title: 'Unidad de Negocio', property: 'BusinessCoreName', visible: true },
        { title: 'Cuenta Contable Anticipo a Terceros', property: 'ThirdAdvanceAccountantIDStrName', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Crear una base de dinero para una cuenta', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }
    const createMoneyBaseForCashDeskAccount = () => {

        deskcreate.instance.createMoneyBaseForCashDeskAccount(desk.bean.IDCashDeskAccount, deskcreate.bean.IDBankingAccount, deskcreate.bean.Observations, deskcreate.bean.Value, deskcreate.bean.AccountantDate, _single.getAccountID()).then(
            (resp: any) => {
                if (resp) {
                    console.log(resp)
                    setDocs(resp.DocumentURL);
                    setModal({ ...modal, "view": false });
                    setModalverdoc({ ...modalverdoc, "view": true });
                }
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    return (
        <BasicPage titulo="Desembolsar Base para Cajas Menores">
            <div className="row">
                <div className="row">
                    <div className="col-md-6">
                        <OfficeEditor key={conpany} id={office} idconpany={conpany} onchange={(e: any) => { setOffice(e) }}></OfficeEditor>
                    </div>
                    <div className="col-md-6">
                        <CompanyEditor id={conpany} onchange={(e: any) => { setCompany(e); }}></CompanyEditor>
                    </div>
                    <div className="col-md-4 mt-4">
                        <BasicButton eventClick={getLista} icon="ri-search-line" children={"Buscar"} />
                    </div>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={desk.setBean} listButtons={listaBotones()} ></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={createMoneyBaseForCashDeskAccount}>
                        <div className="row">
                            <div className="col-md-12">
                                <BankAccountSelect label="Banco Orígen de Fondos" idSelector={deskcreate.bean.IDBankingAccount} onChange={(e) => { deskcreate.setBean({ ...deskcreate.bean, "IDBankingAccount": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Valor a Girar</label>
                                <input type="text" name="Value" className="form-control" value={deskcreate.bean.Value} onChange={deskcreate.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <InputDate label="Fecha de Registro" name="date" value={deskcreate.bean.AccountantDate} setDate={(e) => { deskcreate.setBean({ ...deskcreate.bean, "AccountantDate": e }) }} ></InputDate>
                            </div>
                            <div className="col-md-12">
                                <label>Observaciones</label>
                                <textarea name="Observations" className="form-control" value={deskcreate.bean.Observations} onChange={deskcreate.handleChange} />
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalverdoc} updateModal={setModalverdoc}>
                        <div className="row">
                            <DocumentViewer
                                list={docs}
                            />
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {desk.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}  